import ApiRouteProvider from '../route'
import axios from '@axios'
import Cache from "@core/api/request/Cache";

export default {
    getCounters() {
        return axios.get(ApiRouteProvider.getBaseUrl() + '/user/counters');
    },

    updateEmailPreferences(preferences) {
        return axios.post(ApiRouteProvider.user.updateEmailPreferences(), preferences);
    },

    updateSettings(settings) {
        return axios.patch(ApiRouteProvider.user.updateSettings(), settings);
    },

    getProfile() {
        return axios.get(ApiRouteProvider.user.profile()).then(r => r.data);
    },

    selectOrganization(id) {
        return axios.post(ApiRouteProvider.user.organizationSelect(), {organizationId: id});
    },

    resetPassword(token, password) {
        return axios.post(ApiRouteProvider.user.resetPassword(), {
            token: token,
            password: password,
        });
    },

    swiftLogin(token) {
        return axios.post(ApiRouteProvider.user.swiftLogin(), {
            token: token,
        });
    },

    getUsers(filters, sorting, page, perPage) {
        return axios.get(ApiRouteProvider.user.getUsers({
            filters,
            sort: sorting,
            page,
            perPage
        }))
    },

    getCard(id) {
        return axios.get(ApiRouteProvider.user.card(id));
    },

    saveCard(id, card) {
        if (id) {
            return axios.put(ApiRouteProvider.user.card(id), card);
        }

        return axios.post(ApiRouteProvider.user.card(), card)
    },

    getSystemRoles() {
        return axios.get(ApiRouteProvider.user.systemRoles());
    },

    getRoles() {
        return axios.get(ApiRouteProvider.user.roles());
    },

    twoFactorAuthenticationIssueCode() {
        return axios.post(ApiRouteProvider.user.twoFactorAuthenticationIssueCode(), {});
    },

    twoFactorAuthenticationVerifyCode(code) {
        return axios.put(ApiRouteProvider.user.twoFactorAuthenticationVerifyCode(), {code});
    }
};
